import { useTranslation } from 'react-i18next';

import flyLogo from '@fly/assets/images/fly_logo.svg';
import { Heading, Text } from '@fly/core';
import { detectPlatform } from '@fly/shared';
import { useDownload } from '@fly/shared-hooks';

import {
  CliInstallCommand,
  DownloadButtons,
  DownloadLayout,
} from './components';

export function Download() {
  const { t } = useTranslation();
  const { detectedConfig, alternativePlatforms, handleDownload } =
    useDownload();
  const platform = detectPlatform();

  return (
    <DownloadLayout
      data-testid='download-page'
      onDownload={() => detectedConfig && handleDownload(detectedConfig)}
    >
      <div className='gap-16 flex w-full max-w-[910px] flex-col'>
        <div className='gap-8 flex items-start'>
          <div className='p-5 flex w-[193px] shrink-0 items-center justify-center rounded-[32px] bg-[var(--gray-a3)]'>
            <img src={flyLogo} alt='JFrog Fly' className='h-[152px] w-auto' />
          </div>
          <div className='gap-8 flex flex-1 flex-col'>
            <div className='gap-3 flex flex-col'>
              <Heading
                as='h1'
                size='8'
                weight='bold'
                className='text-gray-12 leading-[40px] tracking-[-0.16px]'
              >
                {t('app.download.title', { defaultValue: 'Download Fly' })}
              </Heading>
              <Text
                size='5'
                className='text-gray-11 leading-7 tracking-[-0.08px]'
              >
                {t('app.download.description', {
                  defaultValue:
                    'The first agentic artifact repository. AI-native way to store, share, and ship your software packages.',
                })}
              </Text>
            </div>
            <DownloadButtons
              detectedConfig={detectedConfig}
              alternativePlatforms={alternativePlatforms}
              onDownload={handleDownload}
            />
            <CliInstallCommand
              platform={platform}
              detectedConfig={detectedConfig}
              onDownload={handleDownload}
            />
          </div>
        </div>
      </div>
    </DownloadLayout>
  );
}
